module.exports = __webpack_public_path__ + "media/Video 138b.98af947f.mp4";